<div [class]="'snack-bar-container ' + data.type">
  <ng-container *ngIf="data.type === 'error'">
    <mat-icon svgIcon="exclamation-circle"></mat-icon>
  </ng-container>

  <div class="font-milliard-medium font-size-15 message">
    {{ data.message }}
  </div>

  <button mat-icon-button (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
